import {
  VscCheckAll,
  VscCheck,
  VscPassFilled as VscPass,
  VscCircleLarge as VscCircleLargeOutline,
} from 'react-icons/vsc';
import {Box, Typography, useTheme} from '@mui/material';

import {useState, useEffect} from 'react';

export default (props: any) => {
  const theme = useTheme();
  const [selectedOptions, setSelectedOptions] = useState<any>([]);

  const setOption = (option: any) => {
    const isAlreadySelected = selectedOptions.indexOf(option) === -1;
    if (isAlreadySelected) {
      if (props.multiSelect) {
        setSelectedOptions(selectedOptions.concat([option]));
      } else {
        setSelectedOptions([option]);
      }
    } else {
      const filteredOptions = selectedOptions.filter(
        (_option: any) => _option != option
      );
      setSelectedOptions(filteredOptions);
    }
  };
  useEffect(() => {
    if (props.onChange) {
      props.onChange(undefined, selectedOptions);
    }
  }, [selectedOptions]);

  return (
    <Box sx={{p: 0}}>
      {props.options.map((option: any, index: number) => {
        const isSelected =
          selectedOptions.indexOf(option.value || option.id) === -1;
        return (
          <Box
            key={`${props.name}-${index}`}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              color: isSelected
                ? theme.palette.secondary.light
                : theme.palette.primary.main,
              borderBottom: '1px solid #ddd',
              cursor: 'pointer',
              p: theme.spacing(1.2, 2),
            }}
            onClick={() => setOption(option.value || option.id)}
          >
            {isSelected ? (
              <Typography variant="h6">
                {!props.multiSelect ? <VscCheck /> : <VscCircleLargeOutline />}
              </Typography>
            ) : (
              <Typography variant="h6">
                {!props.multiSelect ? <VscCheckAll /> : <VscPass />}
              </Typography>
            )}
            <Typography variant="body2">
              {option.label || option.name}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};
